'use client'
import { useEffect, useState } from 'react'

import { DragDropFileList, FileListFileProps } from '@mercai/clever'

import { getFileNameAndExtension } from '@/helpers'
import { apiNoAuth, PROFILE_FILES_URL, useFileSign } from '@/services'

import { DocumentDragDropCardProps } from './document-drag-drop-card.type'

export const DocumentDragDropCard = ({
  file,
  fileField,
  translations,
  uploadFileSuccess,
}: DocumentDragDropCardProps) => {
  const [fileObj, setFileObj] = useState<FileListFileProps[] | undefined>(
    undefined,
  )

  const { mutateAsync } = useFileSign()

  const getFileValue = (file: string | undefined) => {
    if (!file) {
      return []
    }

    const { fileName, extension } = getFileNameAndExtension(file)

    return [
      {
        id: new Date().getTime(),
        name: `${fileName}.${extension}`,
        url: file as string,
        uploaded: true,
      },
    ]
  }

  const onUpload = (file?: Record<string, string>) => {
    const fileValue = getFileValue(file?.filename)
    setFileObj(fileValue)

    uploadFileSuccess(fileField, file?.filename || '')
  }

  useEffect(() => {
    const getUrl = async (dataSheet: string) => {
      if (!dataSheet) return ''

      if (!dataSheet.includes('http')) {
        const response = await mutateAsync({
          filePath: dataSheet,
        })

        if (!response?.data?.signedUrl) return ''

        return response.data.signedUrl
      }

      return dataSheet
    }

    const fetchData = async () => {
      const url = await getUrl(file)
      const fileValue = getFileValue(url || file)
      setFileObj(fileValue)
    }

    if (file) {
      fetchData()
    }
  }, [file])

  return (
    <DragDropFileList
      axiosInstance={apiNoAuth}
      urlAdd={PROFILE_FILES_URL}
      configsRequest={{
        fileField: 'file',
        method: 'POST',
      }}
      data={fileObj}
      successedUpload={onUpload}
      translations={translations}
      onClickPreview={(url) => window.open(url, '_blank')}
    />
  )
}
